import { injectGlobal } from "styled-components"
import * as vars from "../style/vars"
import { above, below } from "../style/functions"

injectGlobal`
	*,::after,::before{margin:0;padding:0;border:0;border-collapse:collapse;border-spacing:0;box-sizing:border-box;outline:0;font:inherit;vertical-align:baseline;quotes:none}// HTML 5 me bro footer,header,hgroup,menu,nav,section,small{display:block}// No quotes,blockquote:after,please! blockquote:before,q:after,q:before{content:'';content:none}

	html {
		background-repeat: no-repeat;
		font-size: 9px;
		color: ${vars.colors.body};
		font-family: ${vars.fonts.main};
		line-height:1;
		body.fixed {
			height: 100%;
			overflow: hidden;
		}
		${above.giant`
			font-size: 12px;
		`}
		${above.xl`
			font-size: 14px;
		`}
	}

	footer .form__error{
		max-width:90%;
		@media (max-width: 840px){
			max-width:100%;
		}
	}
	/*
	html{
		width: 2000px;
		background-image: url('/images/bg.jpg');
		body{
			width: 2000px;
			opacity: 0.6;
			margin: auto;
		}
	}
	*/
`
import "../style/col.js"
import "../style/util.js"
import "../style/main.js"



// WEBPACK FOOTER //
// ./src/style/css.js